export default __webpack_public_path__ + "static/wunschpiercing-1-0abf858c85c247a35938750f48fb4655.jpg";